export const VERSION = typeof "3.2.10" !== 'undefined' ? "3.2.10" : 'latest';
//# sourceMappingURL=version.js.map